/** Keep the exact accepted request alive: a wallet wait is not a failed shipment or permission to requote. */
export async function settlePendingWalletLabel<
  T extends { data?: { status?: string } },
>(
  initial: T,
  read: () => Promise<T>,
  waiting: () => void,
  active: () => boolean = () => true,
  delay: () => Promise<void> = () =>
    new Promise(resolve => setTimeout(resolve, 3000)),
): Promise<T | undefined> {
  let result = initial;
  while (result.data?.status === 'awaiting_funds') {
    if (!active()) return;
    waiting();
    await delay();
    if (!active()) return;
    try {
      result = await read();
    } catch (error: any) {
      // Keep polling an accepted operation through transient HTTP/gateway outages. Authorization/terminal
      // failures still surface normally; no new quote or request identity is minted here.
      const networkOutage = !error?.code && !error?.status && !error?.response;
      if (
        !networkOutage &&
        error?.code !== 'WALLET_LABEL_PENDING' &&
        Number(error?.status) !== 503 &&
        error?.response?.status !== 503 &&
        error?.code !== 'ERR_NETWORK'
      )
        throw error;
    }
  }
  return active() ? result : undefined;
}
